<div id="crop-health-map-calendar-select-date">
  <div class="calendar-container mt-1">
    <p-datepicker
      id="crop-monitoring-map-calendar"
      class="max-w-full"
      [(ngModel)]="selectedDate"
      (ngModelChange)="onChangeDate()"
      [inline]="true"
      [maxDate]="today"
      [disabledDates]="disabledDates"
      [selectionMode]="selectionMode">
      @if (viewMode === 'day') {
        <ng-template pTemplate="date" let-date let-today="today">
          <span
          class="day"
            [ngClass]="{
              'p-disabled': !isAllowedDate(date),
              'allowed-date': isAllowedDate(date),
              'p-datepicker-today': today,
            }">
            {{ date.day }}
          </span>
        </ng-template>
      }
    </p-datepicker>
  </div>

  <div class="d-flex justify-content-end gap-3 mt-3">
    <dk-button
      id="crop-monitoring-map-calendar-btn"
      [label]="'doktar_app.common.apply' | translate"
      severity="primary"
      [disabled]="!selectedDate || isAllowedDate(selectedDate)"
      (onClick)="apply()" />
  </div>
</div>
